/**
 * This object is instantiated when corresponding definition is added to mxml file.
 */
/**
 * package: com.inq.ui
 * class: XFrame
 * @extends com.inq.ui.IFrame
 * @constructor
 */
com.inq.ui.XFrame = function(_id) {
	com.inq.ui.IFrame.call(this,_id);
	this.initStyle("id",_id);
	this.__src = null;
	this.__oldSource = null;
	this.__initOnLoad = false;
	if (com.inq.utils.Capabilities.isPhone()) {
		/*
		// This solution was implemented to enable scrolling in native automatons on mobile devices,
		// but it breaks native browser scrolling. We've created RTDEV-25452 to rework this.
		this.initTouchScrolling();
		*/
	}
	else if (com.inq.utils.Capabilities.isIpad() || com.inq.utils.Capabilities.isIOSWebView()) {
		this.initFocusOnTouch();
	}
	this.initFocusHandler();
};
$hxClasses.extend(com.inq.ui.IFrame, com.inq.ui.XFrame, "com.inq.ui.XFrame");

/**
 * readPersistedURL
 *
 * $type TFun([{ name => defaultVal, t => TDynamic(null), opt => false }],TInst(String,[]))
 * public function readPersistedURL(defaultVal:Dynamic):String
 * @public
 * @this com.inq.ui.XFrame
 * @param {null}  defaultVal
 * @return {string}
 */
com.inq.ui.XFrame.prototype.readPersistedURL = function(defaultVal) {
	return com.inq.flash.client.control.PersistenceManager.GetValue(com.inq.ui.XFrame.PERSISTENT_URL_COOKIE_PREFIX + this.getID(),defaultVal);
};


/**
 * cloneXFrameData
 * Clone xframe data for persisting. Persisted data is used in various page refresh scenarios so cache is not needed
 * for that purpose and will be stripped off to fit coockie size limitations
 *
 * $type TFun([],TMono(<mono>))
 * private function cloneXFrameData()
 * @private
 * @this com.inq.ui.XFrame
 * @return {Object} - data to persist (w/o cache)
 */
com.inq.ui.XFrame.prototype.cloneXFrameData = function() {
	/** @type {Object} */
	var target = { };
	/** @type {Array} */
	var keyz = Reflect.fields(this.__src);
	var /** @type {number} */ _g1 = 0, /** @type {number} */ _g = keyz.length;
	while(_g1 < _g) {
		var /** @type {number} */ s = _g1++;
		var /** @type {string} */ name = keyz[s];
		if(name != "cacheId") target[name] = this.__src[name];
	}
	return target;
};


/**
 * persistURL
 *
 * $type TFun([],TEnum(Void,[]))
 * public function persistURL():Void
 * @public
 * @this com.inq.ui.XFrame
 * @return {void}
 */
com.inq.ui.XFrame.prototype.persistURL = function() {
	com.inq.flash.client.control.PersistenceManager.SetValue(com.inq.ui.XFrame.PERSISTENT_URL_COOKIE_PREFIX + this.getID(),this.cloneXFrameData());
};


/**
 * loadContent
 *
 * $type TFun([],TEnum(Void,[]))
 * override public function loadContent():Void
 * @override
 * @public
 * @this com.inq.ui.XFrame
 * @return {void}
 */
com.inq.ui.XFrame.prototype.loadContent = function() {
	com.inq.ui.IFrame.prototype.loadContent.call(this);
	this.setInnerHTML(this.__src);
};


/**
 * setInitOnLoad
 *
 * $type TFun([{ name => val, t => TDynamic(null), opt => false }],TDynamic(null))
 * private function setInitOnLoad(val:Dynamic):Dynamic
 * @private
 * @this com.inq.ui.XFrame
 * @param {null}  val
 * @return {null}
 */
com.inq.ui.XFrame.prototype.setInitOnLoad = function(val) {
	if (this._div != null && val == "true") {
		if (this.__src == null) {
			this.__initOnLoad = true;
		} else {
			this.setInnerHTML(this.__src, null, true);
		}
	}
};


/**
 * getInitOnLoad
 *
 * $type TFun([],TDynamic(null))
 * private function getInitOnLoad():Dynamic
 * @private
 * @this com.inq.ui.XFrame
 * @return {null}
 */
com.inq.ui.XFrame.prototype.getInitOnLoad = function() {
	return this.__initOnLoad;
};


/**
 * updateSrc
 * Update XFrame source with possibility to override default business unit ID.
 *
 * $type TFun([{ name => businessUnitID, t => TInst(String,[]), opt => true }],TEnum(Void,[]))
 * override public function updateSrc(?businessUnitID:String):Void
 * @override
 * @public
 * @this com.inq.ui.XFrame
 * @param {string}  businessUnitID -  optional parameter
 * @param initiator initiator who show automaton
 * @return {void}
 */
com.inq.ui.XFrame.prototype.updateSrc = function(businessUnitID, initiator) {
	com.inq.ui.IFrame.prototype.updateSrc.call(this, businessUnitID, initiator);
	if(this.__src != null) {
		if(businessUnitID) {
			this.__src.params.businessUnitID = businessUnitID;
		}
		this.__src["initiator"] = initiator;
	}
};


/**
 * setSrcWithBusinessUnitID
 * Set XFrame source with possibility to override default business unit ID.
 *
 * public function setSrcWithBusinessUnitID(urldata:Dynamic, ?businessUnitID:String):Dynamic
 * @public
 * @this com.inq.ui.XFrame
 * @param {null}  urldata -  source data for XFrame
 * @param {string}  businessUnitID -  optional parameter
 * @return {null}
 */
com.inq.ui.XFrame.prototype.setSrcWithBusinessUnitID = function(urldata,businessUnitID) {
	if(this._div != null) {
		this.__src = urldata;
		if(this.__initOnLoad) {
			this.__initOnLoad = false;
			this.setInnerHTML(this.__src, businessUnitID, true);
		}
	}
};


/**
 * setSrc
 *
 * $type TFun([{ name => val, t => TDynamic(null), opt => false }],TDynamic(null))
 * override private function setSrc(val:Dynamic):Dynamic
 * @override
 * @private
 * @this com.inq.ui.XFrame
 * @param {null}  val
 * @return {null}
 */
com.inq.ui.XFrame.prototype.setSrc = function(val) {
	/** @type {?string} */
	var urldata = com.inq.flash.client.control.FlashPeer.parseXFrameUrl(val);
	if(this.__src == null) urldata = this.readPersistedURL(urldata);
	/* If we are here. then we are getting the first src
	 * and we want to replace it with the one in the persistent data:
	 * get url from persistent, use the supplied one as default.
	 */
	return this.setSrcWithBusinessUnitID(urldata);
};


/**
 * getIJSF
 *
 * $type TFun([],TInst(String,[]))
 * private function getIJSF():String
 * @private
 * @this com.inq.ui.XFrame
 * @return {string}
 */
com.inq.ui.XFrame.prototype.getIJSF = function() {
	/** @type {string} */
	var port = "" == window.location.port?"":":" + window.location.port;
	/** @type {string} */
	var src = window.location.protocol + "//" + (window.location.host + port + window.location.pathname);
	return src;
};


/**
 * equal
 * Shallow object comparison, only 1 level deep
 *
 * $type TFun([{ name => o1, t => TInst(Array,[TMono(<mono>)]), opt => false },{ name => o2, t => TInst(Array,[TMono(<mono>)]), opt => false }],TEnum(Bool,[]))
 * @private
 * @this com.inq.ui.XFrame
 * @param {Array}  o1
 * @param {Array}  o2
 * @return {boolean}
 */
com.inq.ui.XFrame.prototype.equal = function(o1, o2) {
	if (o1 == null) {
		return o2 == null;
	}
	/** @type {Array} */
	var fields = Reflect.fields(o1);
	if (!(fields.length == Reflect.fields(o2).length)) {
		return false;
	}
	var /** @type {number} */ _g1 = 0, /** @type {number} */ _g = fields.length;
	while(_g1 < _g) {
		var /** @type {number} */ s = _g1++;
		if(o1[fields[s]] == o2[fields[s]]) return false;
	}
	return true;
};


/**
 * setInnerHTML
 *
 * $type TFun([{ name => source, t => TDynamic(null), opt => false },{ name => businessUnitID, t => TInst(String,[]), opt => true }],TEnum(Void,[]))
 * private function setInnerHTML(source:Dynamic, ?businessUnitID:String):Void
 * @private
 * @this com.inq.ui.XFrame
 * @param {null}  source
 * @param {string}  businessUnitID
 * @param {boolean} initOnLoad optional, indicates whether the automaton is started during initialization chat skin, default value is "false"
 * @return {void}
 */
com.inq.ui.XFrame.prototype.setInnerHTML = function(source, businessUnitID, initOnLoad) {
	if(this.__oldSource == null || this.__oldSource.url != source.url || !this.equal(this.__oldSource["params"],this.__oldSource["params"])) {
		this.__oldSource = source;
		/** @type {string} */
		var parsedSource = this.evaluateString(source.url);
		this._iframe = com.inq.flash.client.control.FlashPeer.createXFrame(
			this._div,
			parsedSource,
			businessUnitID,
			this.scrolling,
			source["params"],
			source["initiator"],
			{type: "chat", id: this.getID()},
			initOnLoad
		);
	}
};

/**
 * Send CI custom event to XForms view, loaded to this container.
 * @param {string} event event name.
 * @param {object} params the reference to the map of parameters.
 * @return {boolean} successful or unsuccessful sending of the custom event.
 */
com.inq.ui.XFrame.prototype.sendCustomEventToXForms = function(event, params) {
	if (this._iframe && this._iframe.contentWindow && this._iframe.contentWindow.TCXForm) {
		return this._iframe.contentWindow.TCXForm.sendCustomEvent(event, params);
	} else {
		return false;
	}
};

/**
 * This will help ci to set focus on automation input element
 */

com.inq.ui.XFrame.prototype.initFocusOnTouch = function(){
	this.touchStart = $bind(this, this.setFocusOnTouch);
	com.inq.utils.Capabilities.BindListener(this._div, "touchstart", this.touchStart );
};

com.inq.ui.XFrame.prototype.setFocusOnTouch = function(event){
	if(event.target.nodeName.toUpperCase()=="INPUT") {
		if(!event.target.onfocus) {

			event.target.blur();
			event.target.onfocus = com.inq.flash.client.chatskins.ChatTextFocusMonitor.onFocus;
			event.target.onblur = com.inq.flash.client.chatskins.ChatTextFocusMonitor.onBlur;
		}
	}
};

com.inq.ui.XFrame.prototype.resetScrolling = function() {
	if(this.containerOrigTopPos == -1) {
		return;
	}
	this._div.style.top = this.containerOrigTopPos+"px";
	this._div.style.height = this.originalHeight+"px";
	this.containerHeight = 0;
	this.originalHeight = this._div.clientHeight;
};

/**
 * This is will enable scrolling of xframe contents if the xframe parent div is bigger than the screen.Typically on a phone
 */

com.inq.ui.XFrame.prototype.initTouchScrolling = function(){
	this.touchStart = $bind(this,this.initTouchStart);
	com.inq.utils.Capabilities.BindListener(this._div,"touchstart", this.touchStart);
	this.touchMove = $bind(this,this.initTouchMove);
	com.inq.utils.Capabilities.BindListener(this._div,"touchmove", this.touchMove);
	this.touchEnd = $bind(this,this.initTouchEnd);
	com.inq.utils.Capabilities.BindListener(this._div,"touchend", this.touchEnd);

};

com.inq.ui.XFrame.prototype.initFocusHandler = function(){
	this.focusBindedHandler = $bind(this,this.focusHandler);
	com.inq.utils.Capabilities.BindListener(window,"focus", this.focusBindedHandler);
}

com.inq.ui.XFrame.prototype.focusHandler = function(){
	var lt = com.inq.flash.client.control.PersistenceManager.GetValue(LAST_FOCUSED);
	var now = new Date().getTime();
	var timeout = com.inq.flash.client.chatskins.SkinControl.getInitialTimeout() * com.inq.flash.client.chatskins.SkinControl.SEC;
	if(lt && (lt + timeout) < now && !com.inq.flash.client.control.PersistenceManager.GetValue(CHAT_ENGAGED)) {
		haxe.Log.trace("Closing outdated chat because timeout has expired, last focused: " + new Date(lt), {fileName : "XFrame.js", lineNumber : 302, className : "XFrame", methodName : "focusHandler"});
		com.inq.flash.client.chatskins.SkinControl.closeChat();
	} else {
		com.inq.flash.client.control.PersistenceManager.SetValue(LAST_FOCUSED, now, true, true);
	}
}

com.inq.ui.XFrame.prototype.initTouchStart = function(event){
	var childEls,len,clientHeight;
	this.touchStartPos = ((event.touches) ? event.touches[0] : event).screenY;
	this.touchLastPos = this.touchStartPos;
	this.containerTopPos = parseInt(this._div.style.top);
	clientHeight = this._div.clientHeight;
	if (this.containerHeight == 0 || clientHeight<this.originalHeight) { /* this logic will recalculate container height on keyboard up as well as on first touch*/
		this.originalHeight =  clientHeight;
		this.containerHeight = this.originalHeight;
		this.containerOrigTopPos = parseInt(this._div.style.top);
		childEls = this._div.children;
		len = childEls.length;
		for(var i=0;i<len;i++) {
			if(childEls[i].scrollHeight>this.containerHeight) { /* this logic will find out scrollable height of xFrame child elements so that that height will be used for xframe div height*/
				var fElement = window.getComputedStyle(childEls[i].firstElementChild);
				this.containerHeight = childEls[i].scrollHeight;
				if(fElement) {
					this.containerHeight = this.containerHeight - parseInt(fElement.marginTop) - parseInt(fElement.marginBottom); /*excluding child margins from scrollable height*/
				}
			}
		}
        /* RTDEV-21218: The xframe div's height need to be adjusted only for those elements that on focus brings up the keyboard. */
        if(this.hasSpecificElements(this._div, "INPUT") || this.hasSpecificElements(this._div, "SELECT") || this.hasSpecificElements(this._div, "TEXTAREA")) {
            this._div.style.height = this.containerHeight + "px";
        }
	} else if(this.containerHeight > clientHeight) {
		this.originalHeight =  clientHeight;
		this._div.style.height = this.containerHeight+"px";

	}
	/** logic to resize chat on safari**/
	com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari.forceFocus(event);
};

com.inq.ui.XFrame.prototype.initTouchMove = function(event) {
	var t = (event.touches) ? event.touches[0] : event;

	this.touchLastPos = t.screenY;

	event.preventDefault();
	return false;
};

com.inq.ui.XFrame.prototype.initTouchEnd = function(event) {
	var area = Application.GetArea(),bottomBoundry;
	if(Math.abs(this.touchLastPos-this.touchStartPos)>50){ /*actual logic for scrolling*/
		if (area && this.containerTopPos + this.containerHeight > area.h || (this.containerTopPos < this.containerOrigTopPos && this.touchLastPos > this.touchStartPos)) {
			this.containerTopPos =  this.containerTopPos+(this.touchLastPos-this.touchStartPos);
			this.containerTopPos = this.containerTopPos>this.containerOrigTopPos?this.containerOrigTopPos:this.containerTopPos;
			bottomBoundry = this.containerHeight-(area.h-this.containerOrigTopPos);
			this.containerTopPos = this.containerOrigTopPos - this.containerTopPos > bottomBoundry?this.containerOrigTopPos-bottomBoundry:this.containerTopPos;
			this._div.style.top = this.containerTopPos+"px"
		}

	}
};

com.inq.ui.XFrame.prototype.cleanUp = function () {
	com.inq.utils.Capabilities.UnbindListener(this._div,"touchstart",this.touchStart);
	com.inq.utils.Capabilities.UnbindListener(this._div,"touchmove", this.touchMove);
	com.inq.utils.Capabilities.UnbindListener(this._div,"touchend", this.touchEnd);
	com.inq.utils.Capabilities.UnbindListener(window,"focus", this.focusBindedHandler);
};

/**
 * This checks if the parentElement has any visible elements of the given tagName  (RTDEV-21218)
 * @param {string} parentElement
 * @param {string} tagName
 * @return {boolean} true or false
 */
com.inq.ui.XFrame.prototype.hasSpecificElements = function (parentElement, tagName) {
    var arr = parentElement.getElementsByTagName(tagName);
    for (var i=0; i<arr.length; i++) {
        if (!!( arr[i].offsetWidth || arr[i].offsetHeight || arr[i].getClientRects().length )) {//this check is to see if the element is visible in the DOM
            if((tagName == "INPUT" && arr[i].type.toLowerCase()=="text") || (tagName != "INPUT")) {
                return true;
            }
        }
    }
    return false;
}

/** @type {null} */
com.inq.ui.XFrame.prototype.initOnLoad = null;
/** @private @type {null} */
com.inq.ui.XFrame.prototype.__initOnLoad = null;
/** @private @type {null} */
com.inq.ui.XFrame.prototype.__oldSource = null;
/** @private @type {null} */
com.inq.ui.XFrame.prototype.__src = null;
/** @type {com.inq.ui.XFrame} */
com.inq.ui.XFrame.prototype.__class__ = com.inq.ui.XFrame;
/** @type {string} */
com.inq.ui.XFrame.PERSISTENT_URL_COOKIE_PREFIX = "CX_";
/** @type {number} */
com.inq.ui.XFrame.prototype.touchStartPos = 0;
com.inq.ui.XFrame.prototype.touchLastPos = 0;
com.inq.ui.XFrame.prototype.containerTopPos = 0;
com.inq.ui.XFrame.prototype.containerOrigTopPos = -1;
com.inq.ui.XFrame.prototype.containerHeight = 0;
com.inq.ui.XFrame.prototype.originalHeight = 0;

